import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classnames from 'classnames';

import { translate as t } from '../../lib/I18n';
import ValidatedFormField from '../form/ValidatedField';

import CVVIcon from '../icons/CVVIcon';


function CardSecurityCode (props) {
    const hideValueProp = props.hideValue ? { disabled: true, value: '', hideError: true } : null;

    return (
        <div className="card-security-code input-with-addon input-with-addon--right">
            <ValidatedFormField { ...props }
                type="tel"
                id="cvv"
                field="cv2"
                name="cvv"
                label={ t('customerdetails.payment.cvv') }
                placeholder={ t('customerdetails.payment.cvv') }
                labelClassName="sr-only"
                autoComplete="cc-csc"
                { ...hideValueProp }
            />

            <div className={classnames("cvv-indicator card-security", { 'card-indicator--outside-label': props.outsideLabel })}>
                <CVVIcon />
            </div>
        </div>
    );
}

CardSecurityCode.propTypes = {
    ..._.pick(ValidatedFormField.propTypes, [
    'form',
    'onChange',
    'disabled',
    'outsideLabel',
    'required',
    'visited',
    'validation'
    ]),
    hideValue: PropTypes.bool
};


export default CardSecurityCode;



// WEBPACK FOOTER //
// ./src/components/payment/CardSecurityCode.js